module.exports = __webpack_public_path__ + "img/stand.faee4bc3.webp";